import {
  CHAT_FOLDER_LIST_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
} from "@frontend-shared/constants";
import type { IDeleteChatFolderParams } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatFolderApi } from "@/api/services";

export const useDeleteChatFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: IDeleteChatFolderParams) =>
      chatFolderApi.deleteChatFolder(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CHAT_FOLDER_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [CHAT_LIST_QUERY_KEY],
      });
    },
  });
};
